export enum AuthorizationType {
    LivedoohCredentials = 1
}